import React from 'react';
import PropTypes from 'prop-types';
import { H2 } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { ReviewCard } from 'components/molecules';
import { generateStars } from 'utils/formatting';
import { formatISODateToReview } from 'utils/dateUtils';
import TrustPilotLogo from 'assets/images/trustpilot/trustpilot-logo.svg';
import { Image } from '@sparefoot/react-core';

import './TrustPilotReviewsSearchContent.scss';

export default function TrustPilotReviewsSearchContent({
	reviews,
	title = 'Customer reviews of SelfStorage.com',
}) {
	if (!reviews || reviews.length === 0) {
		return null;
	}

	return (
		<div className="tp-reviews-search-content">
			<div className="tp-reviews-search-content__header">
				<div className="tp-reviews-search-content__stars">
					{generateStars(4.5, 20, 20, 'green')}
				</div>

				<H2
					color="black"
					size="large"
					weight="medium"
					className="tp-reviews-search-content__title"
				>
					<Image
						src={TrustPilotLogo}
						alt="TrustPilot logo"
						height={35}
					/>

					{title}
				</H2>
			</div>

			<div className="tp-reviews-search-content__list">
				{reviews.map((review, index) => (
					<ReviewCard
						key={`${review.customerName}-${index}`}
						variant="search"
						title={review.title}
						stars={review.stars}
						description={review.text}
						user={review.customerName}
						date={formatISODateToReview(
							review.createdAt || review.reviewDate,
						)}
					/>
				))}
			</div>

			<Link
				quaternary
				underline
				href="https://www.trustpilot.com/review/www.selfstorage.com"
				target="_blank"
				rel="noopener noreferrer"
				className="tp-reviews-search-content__link"
			>
				See more reviews on TrustPilot
			</Link>
		</div>
	);
}

TrustPilotReviewsSearchContent.propTypes = {
	title: PropTypes.string,
	reviews: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			stars: PropTypes.number,
			text: PropTypes.string,
			customerName: PropTypes.string,
			createdAt: PropTypes.string,
			reviewDate: PropTypes.string,
		}),
	),
};
